const SEA_INCOTERMS = new Set(["FAS", "FOB", "CFR", "CIF"]);

const TYPE_RULES = {
  commodity_trade: ["LOI", "DD_QUESTIONS"],
  cross_border_supply: ["LOI", "DD_QUESTIONS", "BANK_CHECKLIST"],
  shipping_chartering: ["RECAP", "OWNERS_LETTER"],
  trade_finance_prep: ["BANK_CHECKLIST", "RED_FLAG_MEMO"],
  corporate_dd: ["DD_QUESTIONS", "RED_FLAG_MEMO", "MGMT_SUMMARY"],
  "Commercial Drafting": ["LOI", "DD_QUESTIONS"],
  "Documentary Support": ["BANK_CHECKLIST", "RED_FLAG_MEMO"],
  "Shipping & Chartering": ["RECAP", "OWNERS_LETTER"],
  "Management Desk": ["MGMT_SUMMARY", "NEXT_STEP"],
};

const STAGE_RULES = {
  initial_enquiry: ["LOI"],
  counterparty_review: ["DD_QUESTIONS", "RED_FLAG_MEMO"],
  negotiation: ["SOFT_OFFER", "NEXT_STEP"],
  offer_quotation: ["PROFORMA_INVOICE", "SOFT_OFFER", "FCO"],
  contract_preparation: ["SPA", "FCO", "ICPO"],
  payment_instrument: ["BANK_CHECKLIST"],
  pre_shipment: ["COMMERCIAL_INVOICE", "PACKING_LIST", "BANK_CHECKLIST"],
  shipment: ["COMMERCIAL_INVOICE", "PACKING_LIST"],
  document_presentation: ["COMMERCIAL_INVOICE", "PACKING_LIST", "BANK_CHECKLIST"],
  completed: ["MGMT_SUMMARY"],
};

function paymentTemplate(deal) {
  const payment = deal?.parameters?.payment || {};
  const value = [payment.method, payment.instrument, payment.payment_instrument]
    .filter(Boolean).join(" ").toUpperCase();
  if (value.includes("SBLC")) return "SBLC_DRAFT";
  if (value.includes("BCL") || value.includes("BANK COMFORT")) return "BCL_DRAFT";
  if (/\bLC\b|LETTER OF CREDIT|DOCUMENTARY CREDIT/.test(value)) return "LC_DRAFT";
  return null;
}

export function recommendDocumentPack(deal, drafts = []) {
  const recommendations = new Map();
  const add = (code, reasonKey, priority) => {
    if (!code) return;
    const current = recommendations.get(code);
    if (!current || priority > current.priority) recommendations.set(code, { code, reasonKey, priority });
  };

  (TYPE_RULES[deal?.deal_type] || ["NEXT_STEP"]).forEach((code, index) =>
    add(code, "doc_pack_reason_type", 80 - index)
  );
  (STAGE_RULES[deal?.stage] || []).forEach((code, index) =>
    add(code, "doc_pack_reason_stage", 100 - index)
  );

  const paymentCode = paymentTemplate(deal);
  if (paymentCode) {
    add(paymentCode, "doc_pack_reason_payment", 110);
    add("BANK_CHECKLIST", "doc_pack_reason_payment", 105);
  }

  const delivery = deal?.parameters?.delivery || deal?.parameters?.logistics || {};
  if (SEA_INCOTERMS.has(String(delivery.incoterms || "").toUpperCase()) &&
      ["pre_shipment", "shipment", "document_presentation"].includes(deal?.stage)) {
    add("RECAP", "doc_pack_reason_shipping", 95);
  }

  const draftsByCode = new Map();
  for (const draft of drafts) {
    const current = draftsByCode.get(draft.template_code);
    if (!current || (draft.version_number || 1) > (current.version_number || 1)) {
      draftsByCode.set(draft.template_code, draft);
    }
  }

  return [...recommendations.values()]
    .sort((a, b) => b.priority - a.priority || a.code.localeCompare(b.code))
    .slice(0, 6)
    .map((item) => ({ ...item, draft: draftsByCode.get(item.code) || null }));
}

export function isDraftOutdated(deal, draft) {
  if (!deal || !draft?.deal_id) return false;
  return Number(draft.deal_master_revision || 0) < Number(deal.master_data_revision || 0);
}
